import request from "@/utils/request";

// 查询评论列表
export function getCommentList(params) {
  return request({
    url: "/admin/comments",
    method: "get",
    params: params
  });
}

//删除评论
export function moveToRecycle(data) {
  return request({
    url: "/admin/comments/recycle",
    method: "put",
    data: data
  });
}

//恢复评论
export function backFromRecycle(data) {
  return request({
    url: "/admin/comments/back",
    method: "put",
    data: data
  });
}

//物理删除评论
export function removeComments(data) {
  return request({
    url: "/admin/comments",
    method: "delete",
    data: data
  });
}
